export const sanitizeNumberInput = (value = "") => {
  if (typeof value !== "string") {
    value = String(value ?? "");
  }
  return value.replace(/[^0-9]/g, "");
};

export const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined) return "";
  const sanitized = sanitizeNumberInput(value);
  if (!sanitized) return "";
  return Number(sanitized).toLocaleString("en-US");
};

